if (!customElements.get('slider-carousel')) {
  customElements.define(
    'slider-carousel',
    class SliderCarousel extends HTMLElement {
      constructor() {
        super();

        this.progress = this.querySelector(".autoplay-progress");
        this.progress.style.setProperty("--cursor-color", this.getAttribute("cursor-color"));
        this.progress.style.setProperty("--cursor-background", this.getAttribute("cursor-background"));
        this.progressCircle = this.querySelector(".autoplay-progress svg");
        this.progressContent = this.querySelector(".autoplay-progress span");
        this.btnNext = this.querySelector(".swiper-button-next");
        this.btnPrev = this.querySelector(".swiper-button-prev");

        const self = this

        this.swiper = new Swiper("slider-carousel .swiper", {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: this.getAttribute("loop") == "true",
          centeredSlides: true,
          effect: this.getAttribute("effect"),
          direction: this.getAttribute("direction"),
          autoplay: {
            delay: parseInt(this.getAttribute("duration")) * 1000,
            disableOnInteraction: false
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              const span = '<span>' + (index + 1) + "</span>";
              const navigation = `<button type="button" class="${className}">
                              <svg viewBox="0 0 48 48">
                                <circle cx="24" cy="24" r="21"></circle>
                              </svg>
                              ${span}
                            </button>`
              return navigation
            },
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          on: {
            autoplayTimeLeft(s, time, progress) {
              self.progressCircle.style.setProperty("--progress", 1 - progress);
              self.querySelectorAll(".swiper-pagination-bullet svg").forEach(function (item) {
                item.style.setProperty("--progress", 1 - progress);
              })
            }
          }
        });

        this.querySelectorAll(".swiper .swiper-pagination-bullet").forEach(item => {
          item.style.setProperty("--pagination-color", self.getAttribute("pagination-color"));
          item.style.setProperty("--pagination-background", self.getAttribute("pagination-background"));
          item.addEventListener("mousemove", (e) => {
            e.stopPropagation()
            e.preventDefault()
            self.progress.style.display = "none"
          })
        })

        if (this.querySelectorAll(".swiper .swiper-slide").length >= 2) {

          this.querySelector(".swiper").addEventListener("pointerleave", function (e) {
            e.stopPropagation()
            e.preventDefault()
            self.progress.style.display = "none"
          })

          this.querySelector(".swiper").addEventListener("mousemove", function (e) {
            e.stopPropagation()
            e.preventDefault()

            // Get the bounding rectangle of target
            const rect = this.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            self.progress.style.top = (y) + "px"
            self.progress.style.left = (x - 25) + "px"
            self.progress.style.display = "flex"

            const wdithMiddle = rect.width / 2;
            if (x > wdithMiddle) {
              self.progressContent.textContent = ">"
            } else {
              self.progressContent.textContent = "<"
            }
          })

          this.querySelector(".swiper").addEventListener("click", function (e) {
            // Get the bounding rectangle of target
            const rect = this.getBoundingClientRect();
            const x = e.clientX - rect.left;

            const wdithMiddle = rect.width / 2;
            if (x > wdithMiddle) {
              self.btnNext.click()
            } else {
              self.btnPrev.click()
            }
          })

        } else {
          self.progress.style.display = "none"
          this.querySelector(".swiper").style.cursor = "default";
        }
      }
    }
  );
}